import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Button, Icon } from 'antd';

const defaultProps = {
  theme: '',
  handleAddClick: null
};
const propTypes = {
  intl: intlShape.isRequired,
  theme: PropTypes.string,
  handleAddClick: PropTypes.func,
};

const Buttons = ({ intl, theme, handleAddClick }) => {
  const i18nPrefix = 'page.filterCriteria';
  const { formatMessage } = intl;

  return (
    <Button
      size="small"
      className={`ml-sm ${theme}-theme-btn`}
      onClick={handleAddClick}
    >
      <Icon className="font-sm" type="plus" />
      {formatMessage({ id: `${i18nPrefix}.buttons.newFilter` })}
    </Button>
  );
};

Buttons.defaultProps = defaultProps;
Buttons.propTypes = propTypes;
export default injectIntl(Buttons);



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/components/Buttons/index.jsx